import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";

export const uploadCJWFile = async (file, isApproved, threshold, classType) => {
    const fileFormData = new FormData();
    fileFormData.append('cjw-file', file);
    // fileFormData.append('is-approved', isApproved);
    // fileFormData.append('threshold', '10.5');
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
    }
    let apiUrl =
        localDatabaseUrls.baseURL +
        localDatabaseUrls.serviceURL.cjwUploadFile+ '?is-approved='+isApproved+'&threshold='+threshold+'&napa-flag='+classType;

    // let fakeAPI = "https://api.escuelajs.co/api/v1/files/upload"

    return await postAPI(apiUrl,fileFormData,tokenInfo);
    // return await fetch(apiUrl, {
    //     method: "POST",
    //     headers: localDatabaseUrls.temp_headers,
    //     // headers: {
    //     //     Authorization: 'Bearer ' + tokenInfo.id_token,
    //     //     Principal: tokenInfo.access_token,
    //     // },
    //     body: fileFormData 
    //     // file: file
    // });
}
